'use client';

import { DebtEquityValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: DebtEquityValues;
  onValuesChange: (field: keyof DebtEquityValues, value: number | string) => void;
  translations: ToolsTranslations['debtEquity'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof DebtEquityValues, value: string) => {
    const cleaned = value.replace(/\s/g, '');
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue) && numValue >= 0) {
      onValuesChange(field, numValue);
    }
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="total-debt" className="block text-sm font-medium text-gray-700">{translations.totalDebt}</label>
        <div className="relative">
          <input id="total-debt" type="text" value={values.totalDebt.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('totalDebt', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="equity" className="block text-sm font-medium text-gray-700">{translations.equity}</label>
        <div className="relative">
          <input id="equity" type="text" value={values.equity.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('equity', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
    </div>
  );
}


